<div class="range-input" #rangeBox>
  <div class="range-input__header">
    <i class="iconsax range-input__icon" [attr.icon-name]="icon()"></i>
    <span class="range-input__label">{{ label() }}</span>
  </div>
  <!-- slider values -->
  <!-- slider values -->
  <div class="range-input__values">
    <p class="values-label">{{ 'global.from' | translate }}</p>
    <p class="min-val">
      <span>{{ minVal | number }}</span>
      <span> ({{ currentCurrency === 'usd' ? '$' : 'T' }}) </span>
    </p>
    <p class="values-label normal-case">{{ 'global.to' | translate }}</p>
    <p class="max-val">
      <span>{{ maxVal | number }}</span>
      <span> ({{ currentCurrency === 'usd' ? '$' : 'T' }}) </span>
    </p>
  </div>
  <!-- slider input -->
  <div class="range-input__fields">
    <input
      class="range-input__thumb range-input__thumb--left"
      type="range"
      [min]="minRange()"
      [max]="maxRange()"
      [value]="minVal"
      [step]="rangeStep()"
      (change)="setMinValue($event)" />
    <input
      class="range-input__thumb range-input__thumb--right"
      type="range"
      [min]="minRange()"
      [max]="maxRange()"
      [value]="maxVal"
      [step]="rangeStep()"
      (change)="setMaxValue($event)" />

    <div class="range-input__slider">
      <div class="slider-track"></div>
      <div #range class="slider-range"></div>
      <p class="min-range">
        {{ minRange() | number }}
        {{
          currentCurrency === 'usd'
            ? '$'
            : ('enums.currencies.' + currentCurrency | translate)
        }}
      </p>
      <p class="max-range">
        {{ maxRange() | number }}
        {{
          currentCurrency === 'usd'
            ? '$'
            : ('enums.currencies.' + currentCurrency | translate)
        }}
      </p>
    </div>
  </div>
</div>
